import { ValidatorFn } from '@angular/forms';
import { CaFullFormField } from './ca-full-form.types';

export const certificateMaxValidityYearsNotExceedsValidityYears: ValidatorFn =
  control => {
    const certificateMaxValidityYearsValueStr = control.value;
    if (!certificateMaxValidityYearsValueStr) return null;
    const certificateMaxValidityYearsValue = parseInt(
      certificateMaxValidityYearsValueStr,
    );
    const form = control.parent;
    if (!form) return null;
    if (Array.isArray(form.controls)) return null;
    const validityYearsControl = form.controls[CaFullFormField.validityYears];
    if (!validityYearsControl) return null;
    const validityYearsValueStr = control.value;
    if (!validityYearsValueStr) return null;
    const validityYearsValue = parseInt(validityYearsValueStr);
    if (certificateMaxValidityYearsValue <= validityYearsValue) return null;
    return { certificateMaxValidityYearsExceedsValidityYears: true };
  };
